(() => {
  const mobile = window.matchMedia('(max-width: 767px)');

  function initialize(root = document) {
    const galleries = root.querySelectorAll(
      '.product-section slider-component .product__media-list'
    );

    galleries.forEach((gallery) => {
      if (gallery.dataset.adaptiveHeightInitialized) return;
      gallery.dataset.adaptiveHeightInitialized = 'true';

      let animationFrame;

      function updateHeight() {
        if (!mobile.matches) {
          gallery.style.removeProperty('height');
          return;
        }

        const slides = [...gallery.children].filter(
          (slide) =>
            slide.classList.contains('slider__slide') &&
            getComputedStyle(slide).display !== 'none'
        );

        if (!slides.length) return;

        const activeSlide = slides.reduce((closest, slide) => {
          const slideDistance = Math.abs(
            slide.offsetLeft - gallery.scrollLeft
          );

          const closestDistance = Math.abs(
            closest.offsetLeft - gallery.scrollLeft
          );

          return slideDistance < closestDistance ? slide : closest;
        });

        const visibleMedia = [
          ...activeSlide.querySelectorAll(
            '.product-media, video, model-viewer'
          ),
        ].find((media) => media.getBoundingClientRect().height > 0);

        const height = Math.ceil(
          (visibleMedia || activeSlide).getBoundingClientRect().height
        );

        if (height) {
          gallery.style.height = `${height}px`;
        }
      }

      function scheduleUpdate() {
        cancelAnimationFrame(animationFrame);
        animationFrame = requestAnimationFrame(updateHeight);
      }

      gallery.addEventListener('scroll', scheduleUpdate, {
        passive: true,
      });

      gallery.addEventListener('load', scheduleUpdate, true);
      window.addEventListener('resize', scheduleUpdate, {
        passive: true,
      });

      mobile.addEventListener('change', scheduleUpdate);

      new MutationObserver(scheduleUpdate).observe(gallery, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class'],
      });

      scheduleUpdate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();